import React, { Component } from 'react'
import moment from "moment";
import FilterActiveIcon from "../../icons/filteractiveicon";
import FilterIcon from "../../icons/filtericon";
import service from "../../services";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../redux/bindActionCretor";

import ReactPaginate from "react-paginate";

let sub;
let statusFilterList = []
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class MobileAppList extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          // isExist:true,
          // filmAccessData:'',
          // filmAccessDate:'',
          // userEmail:'',
          // showPass:false,
          // password:'',
          // pin:'',
          // exploreShortProgramList: [],
          loaderFlag: false,
          offset: 0,
          perPage: 50,
          currentPage: 0,
          date: [],
          statusArray: [
            { assign: "Sent", list: 1, value: false },
            { assign: "Draft", list: 2, value: false },
          ],
        };
        this.apiserve = new service();
      }
    
    componentWillUnmount = () => {
       sub.unsubscribe();
       statusFilterList = [];
    };
    
     componentDidMount = () => {
      this.setState({
          offset: 1,
          perPage: 50,
          currentPage: 0,
      }, () => this.getAllNotificationList(1, this.state.perPage));
      
        sub = this.apiserve.getevent().subscribe((response) => {
          switch (response.event) {
            case "admin|getAllNotification":
                if(!response.error){
                    this.setState({
                        MobileAppList: response.data?.docs || [],
                        pageCount: Math.ceil((response.data?.totalDocs || 0) / this.state.perPage),
                        loaderFlag: false,
                    })
                }
             
              break;
            
                // case "user|checkStatus":
                //   if(!response.error){
                //       this.setState({
                //           isExist:response.data.isExist,
                //           userEmail:response?.data?.user
                //       })
                //   }else{
                //       this.apiserve.error(response.data.error ? response.data.error : response.data)
                //   }
                //   break;
                  // case "admin|screening|getMasterLink":
                  // if(!response.error){
                  //     this.setState({
                  //        linkCopy:response?.data?.link
                  //     })
                  // }else{
                  //     this.apiserve.error(response.data.error ? response.data.error : response.data)
                  // }
                  // break;
              
            default:
              break;
          }
        });
    };

    getAllNotificationList = (skip, limit) => {
        this.setState({
          loaderFlag: true
      })
        var data = {
          page: skip,
          limit: limit,
        };

        if (statusFilterList && statusFilterList.length) {
            data.status = statusFilterList;
          }
        this.apiserve.sendevent("admin|getAllNotification", data);
      };

      handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
          {
            currentPage: selectedPage,
            offset: offset,
            loaderFlag: true,
          },
          () => {
            // localStorage.setItem('currentPage',this.state.currentPage)
            // localStorage.setItem('offset',offset)
            // localStorage.setItem('perPage',this.state.perPage)
            this.getAllNotificationList(offset, this.state.perPage);
          }
        );
      };

      StatusFilter = (e, selectedInex, isClearStatusType = false,isClearProgramType) => {
        let index = selectedInex;
        let event = e && e.target && e.target.checked;
        let approvePassList = [...this.state.statusArray];
        approvePassList.forEach((key, i) => {
          if (i === index) {
            approvePassList[i].value = event;
          }
          if (isClearStatusType) {
            approvePassList[i].value = false;
            statusFilterList = [];
          }
        });
        this.setState(
          {
            ...this.state,
            statusArray: approvePassList,
            currentPage: 0,
          },
          () => {
            if (event) {
              if (index !== null) {
                statusFilterList = [
                  ...statusFilterList,
                  this.state.statusArray[index].list,
                ];
              }
            } else {
              if (index !== null) {
                let tempArray = statusFilterList.filter(
                  (d) => d !== this.state.statusArray[index].list
                );
                statusFilterList = tempArray;
              }
            }
            this.getFilmFilter(
              this.state.offset,
              this.state.perPage,
              isClearStatusType,
              isClearProgramType
            );
          }
        );
      };
    
      getFilmFilter = (skip, limit, isClearStatusType) => {
        let data = {
          page: 1,
          limit: limit,
        };
    
        if (!isClearStatusType && statusFilterList && statusFilterList.length == 1) {
          data.status = statusFilterList[0] == 1 ? "Sent" : "Draft";
        }
    
         this.apiserve.sendevent("admin|getAllNotification", data);
      };

      editShortProgramList = (item) => {
        this.props.NotificationEditData(item)
        this.props.history.push({
          pathname: "/notification-create",
        });
      };
    
    ScreenerPopup = (e,data,filmData) => {
      e.stopPropagation();
      this.setState({
          screenmodal:true,
          ScreenerPopupData:data,
          ScreenerPopupFilmData:filmData
      })
    }

    scannerLogin = (e,item) => {
      e.stopPropagation();
      e.preventDefault();
      let data = {}
      data.film = item._id
      data.filmType = 'ShortProgramme'
      let scannerLogin = this.apiserve.encrypt(data)
      window.open(process.env.REACT_APP_FRONTEND_ORIGIN_CMS + 'moderator/signin?data=' + scannerLogin);

      // this.props.history.push('/screening-signin')
    }

    scannerSave = (date,data) => {
        
      const isValid = this.validate()
      if (isValid) {
      var data = {
          "filmId": data._id,
          "date": date._id,
          "filmType": "ShortProgramme",
          "password": this.state.password
      }
      this.apiserve.sendevent("fpg|screenerCredential|addPassword",data);
    }
    }

  validate = () => {
    let passwordErr = '';
    if (!this.state.password) {
        passwordErr = 'Password can not be blank'
    }
    else {
        if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
            passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
        }
    }

    this.setState({
        passwordErr
    })
    if (passwordErr) {
        return false
    }
    return true
  }

  onInputChange = (e) => {
    const {name,value} = e.target
    this.setState({
        [name]:value
    })
  }
    
  Showpassword = () => {
    this.setState({
        showPass: !this.state.showPass
    })
}

ClickAddScreenerPopup = (e,item,date) => {
  e.stopPropagation();
  this.setState({
      addScreenerPopup : true,
      filmAccessData: item,
      filmAccessDate:item._id
  })
}
CloseModal = () => {
  this.setState({
      addScreenerPopup:false
  })
}

  setEmailGo = (e) => {
    e.preventDefault();
    var data = {
      email:this.state.email
    }
    this.apiserve.sendevent("user|checkStatus",data);
  }  
    render() {
        const { MobileAppList, statusArray, ScreenerPopupData,ScreenerPopupFilmTitle,ScreenerPopupFilmData } = this.state;
        return (
            <div className="table_wrap film_list_table striped_table notification_table">
              <table className="row_height_tbl">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Message</th>
                    <th>Redirection Type</th>
                    <th>Params</th>
                    <th>Date-Time (MT)</th>
                  </tr>
                </thead>
                <tbody>
                {MobileAppList &&
                  MobileAppList.length > 0 &&
                  MobileAppList.map((item) => {
                      const actionValue = item.actionValue || {};
                      const ctaTypeLabel = actionValue.type === 'page'
                        ? 'App Page'
                        : actionValue.type === 'url'
                          ? 'External URL'
                          : 'None';
                      const reservedKeys = ['path', 'type'];
                      const paramEntries = Object.entries(actionValue)
                        .filter(([k]) => !reservedKeys.includes(k));
                      return(
                        <tr key={item._id} onClick={item.status === 'Draft' ? () => this.editShortProgramList(item._id) : undefined } className={`pointer ${item.status === 'Draft' ? 'disable': ''}`}>
                        <td>
                          <div className="disp_flex">
                            <div className="film_desc disp_flex ml_0" style={{gap:10}}>
                              <img
                                src={item.image || '/images/image-placeholder.png'}
                                alt={item.title || 'Notification'}
                                onError={(e) => { e.target.src = '/images/image-placeholder.png'; }}
                                style={{width:'80px', height:'60px', objectFit:'cover', borderRadius:'4px', flexShrink:0}}
                              />
                              <h3>{item.title}</h3>
                            </div>
                          </div>
                        </td>
                        <td>
                          {item.message}
                        </td>
                        <td>
                          {ctaTypeLabel}
                          {actionValue.path && <div style={{fontSize:'11px', color:'#888', marginTop:'2px'}}>{actionValue.path}</div>}
                        </td>
                        <td>
                          {paramEntries.length > 0
                            ? paramEntries.map(([k, v]) => <div key={k} style={{fontSize:'11px'}}><strong>{k}:</strong> {v}</div>)
                            : '—'}
                        </td>
                        <td>
                          {moment(item.updatedAt).tz("US/Mountain").format('MMM DD, YYYY - h:mm A')}
                        </td>
                      </tr>
                      )

                })}
                </tbody>
              </table>

           




               {/* ReactPaginate  */}
              {this.state.MobileAppList &&
              this.state.MobileAppList.length &&
              this.state.MobileAppList ? (
                <div className="custom-pagination">
                  <ReactPaginate
                    previousLabel={""}
                    nextLabel={""}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    forcePage={this.state.currentPage}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
            
        )
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MobileAppList);